import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-17 ant-col-xl-17" }, null, -1)
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_14 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_iss_retido = _resolveComponent("selecionar-iss-retido")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 950,
    centered: "",
    "wrap-class-name": (_ctx.state.telaMobile ? 'full-modal' : '')
  }, {
    title: _withCtx(() => [
      _createTextVNode("Detalhes do Serviço")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_ctx.props.editavel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
              }, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_form_item, {
                  label: "Discriminação",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.item.discriminacao) = $event)),
                      disabled: !_ctx.props.editavel
                    }, null, 8, _hoisted_7), [
                      [_vModelText, _ctx.state.item.discriminacao]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_form_item, {
                    label: "Atividade Econômica",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        class: "ant-input",
                        value: _ctx.props.item.descricaoAtividadeEconomica,
                        disabled: ""
                      }, null, 8, _hoisted_10)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_form_item, {
                    label: "Local da Prestação",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        class: "ant-input",
                        value: _ctx.servicoServico.apresentacaoLocalPrestacaoServico(_ctx.props.item.localPrestacaoServico),
                        disabled: ""
                      }, null, 8, _hoisted_12)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_form_item, {
                    label: "ISS Retido",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_iss_retido, {
                        valor: _ctx.state.item.impostos.issRetido,
                        "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.item.impostos.issRetido) = $event)),
                        disabled: !_ctx.props.editavel
                      }, null, 8, ["valor", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_a_form_item, {
                    label: "% ISS",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        valor: _ctx.state.item.impostos.aliquotaIss,
                        "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.item.impostos.aliquotaIss) = $event)),
                        percentual: true,
                        disabled: !_ctx.props.editavel
                      }, null, 8, ["valor", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_form_item, {
                    label: "Valor IR",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        valor: _ctx.state.item.impostos.valorIr,
                        "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.item.impostos.valorIr) = $event)),
                        monetario: true,
                        disabled: !_ctx.props.editavel
                      }, null, 8, ["valor", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_form_item, {
                    label: "Valor INSS",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        valor: _ctx.state.item.impostos.valorInss,
                        "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.item.impostos.valorInss) = $event)),
                        monetario: true,
                        disabled: !_ctx.props.editavel
                      }, null, 8, ["valor", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_form_item, {
                    label: "% PIS",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        valor: _ctx.props.item.impostos.aliquotaPis,
                        percentual: true,
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_a_form_item, {
                    label: "% COFINS",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        valor: _ctx.props.item.impostos.aliquotaCofins,
                        percentual: true,
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_a_form_item, {
                    label: "% CSLL",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        valor: _ctx.props.item.impostos.aliquotaCsll,
                        percentual: true,
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}